import { useEffect, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isSoundEnabled, setSoundEnabled, playAddToCart } from '../utils/sound';

/**
 * Tiny header toggle for ambient sound effects.
 * - Defaults ON.
 * - Plays a quick "tink" when re-enabled so the user gets immediate feedback.
 */
export default function SoundToggle({ className = '' }) {
  const [on, setOn] = useState(true);

  useEffect(() => {
    setOn(isSoundEnabled());
    const onSync = (e) => setOn(!!e.detail?.enabled);
    window.addEventListener('jsf-sound-toggle', onSync);
    return () => window.removeEventListener('jsf-sound-toggle', onSync);
  }, []);

  const toggle = () => {
    const next = !on;
    setSoundEnabled(next);
    setOn(next);
    if (next) {
      // Tiny preview tone so the user hears that sound is now on
      setTimeout(() => playAddToCart(), 50);
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="sound-toggle-btn"
      title={on ? 'Mute sounds' : 'Enable sounds'}
      aria-label={on ? 'Mute sounds' : 'Enable sounds'}
      className={`text-white/60 hover:text-[#D4AF37] transition-colors ${className}`}
    >
      {on
        ? <Volume2 className="w-4 h-4" />
        : <VolumeX className="w-4 h-4" />}
    </button>
  );
}
